import React, { useRef, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  useCanvasSSOMutation,
  useInitiateSiteSwitchLogMutation,
  useNavigateToClassicCastleMutation
} from '../../features/authentication/authApiSlice';
import { bytesToBase64 } from '../../utils/pdfUtils';

export default function Index() {
  const navigate = useNavigate();
  const [canvasSso] = useCanvasSSOMutation();
  const [navToClassic] = useNavigateToClassicCastleMutation();
  const [initialiseSiteSwitchLog] = useInitiateSiteSwitchLogMutation();
  const reWriteUrl = useRef('');
  const { url, email } = useParams();

  useEffect(() => {
    canvasSSOAsync();
  }, []);

  const canvasSSOAsync = async () => {
    try {
      const base64Encoded = bytesToBase64(new TextEncoder().encode(email));
      const option = {
        email: base64Encoded
      };
      const authResponse = await canvasSso(option).unwrap();

      if (!authResponse.isSuccess && authResponse.reason == 'SuperAdminAccessRequired') {
        navigate('superAdminLogin');
      }else if (authResponse.redirectUrl){
        await redirectToClassic(authResponse);
      }else {
        if(url && authResponse.redirectUrl){
          await redirectToClassic(authResponse);
          return;
        }
        navigate('/dashboard');
      }
    } catch (ex) {
      console.log('Exception', ex);
      navigate('/login');
    }
  };

  const redirectToClassic = async(authResponse) => {
    var options = {
      reWriteUrl: authResponse.redirectUrl,
      selectedCenter: authResponse.redirectUrl.includes('AdminHome') ? 'AdminHome' : authResponse.redirectUrl.includes('TeacherHome') ? 'TeacherHome' : 'StudentHome'
    };
    if(url)
      options.urlGuid = url;

    const response = await navToClassic(options);
    if (response.error) {
      console.log(response.error.data.error); 
    } else {
      reWriteUrl.current = response.data.returnUrl;
      await handleSiteSwitchLog();
    }
  };

  const handleSiteSwitchLog = async () => {
    try {
      var response = await initialiseSiteSwitchLog();
      window.location.href = reWriteUrl.current + '&logId=' + response.data;
    } catch (ex) {
      console.log(ex);
    }
  };

  return (
    <>Redirecting...</>
  );
}
